import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import NavBar from '../components/Menu/NavBar'
import { pageStyle } from '../components/UIComponent/CommonStyle'
import ApprovalHistory from '../components/LeaveApproval/ApprovalHistory';
import { setLocalStorageSettings } from '../components/Function/globalFunction';

const useStyles = makeStyles(() => ({
    ...pageStyle()
}));

export default function ApprovalHistoryPage({ routing, routingId }) {
    const classes = useStyles();
    setLocalStorageSettings({
        'selectedIndex': 6,
        'isMyRequestOpen': 'false',
        'isApplicationOpen': 'false',
        'isLeaveApprovalOpen': 'true',
        'isHRAdminOpen': 'false'
    });

    return (
        <div className={classes.root}>
            <CssBaseline />
            <NavBar />
            <ApprovalHistory />
        </div>
    )
}